import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavRooms({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15.6 13.2h-2V4.84c0-.69-.54-1.24-1.2-1.24H9.6v1.6H12v9.6h3.6a.4.4 0 00.4-.4v-.8a.4.4 0 00-.4-.4zM7.8 2.03L3 3.27c-.35.1-.6.42-.6.8v9.13h-2a.4.4 0 00-.4.4v.8c0 .22.18.4.4.4h8.4V2.83a.8.8 0 00-1-.8zM6.6 9.2c-.33 0-.6-.36-.6-.8 0-.44.27-.8.6-.8.33 0 .6.36.6.8 0 .44-.27.8-.6.8z" />
    </svg>
  );
}

SvgNavRooms.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavRooms.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavRooms svgRef={ref} {...props} />);
export default ForwardRef;
